import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { BasicConfigService } from '@core/service/basicConfig.service';
import { ResizeObserver } from '@juggle/resize-observer';

@Component({
  selector: 'layout-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.less']
})
export class LayoutTopComponent implements OnInit, OnDestroy {
  private ro: ResizeObserver;
  WorkersData: { [key: string]: any };

  constructor(private readonly router: Router, private readonly configService: BasicConfigService) {
    this.WorkersData = this.configService.get<{ [key: string]: any }>('CustonMadeConfig');
  }

  ngOnInit() {
    this.ro = new ResizeObserver((entries, observer) => {
      for (const entry of entries) {
        const { left, top, width, height } = entry.contentRect;
        const contentElement = document.querySelector<HTMLElement>('.top-content');
        contentElement.style['margin-top'] = `${56 + height}px`;
      }
    });

    const titleElement = document.querySelector<HTMLElement>('.top-title');
    this.ro.observe(titleElement);
  }

  ngOnDestroy(): void {
    this.ro?.disconnect();
  }

  goHome() {
    if (environment.MAIN_URL) {
      window.open(environment.MAIN_URL, '_self');
    } else {
      this.router.navigateByUrl('/');
    }
  }

  get mainUrl() {
    return environment.MAIN_URL;
  }
}
